
import lazyload from "@/directives/lazyload";
import logo from "@/assets/images/landing/svg/big-logo.svg";
export default {
  data() {
    return {
      displaySearches: "772659",
      displayFound: "231798",
      images: {
        logo,
      },
    };
  },
  directives: {
    lazyload,
  },
  mounted() {
    this.outNumSearches(772659, 2135);
    this.outNumFound(231798, 862);
    this.myWindow = window;
  },
  methods: {
    outNumSearches(num, step) {
      var time = 100000;
      var n = 325664;
      var t = Math.round(time / (num / step));
      let interval = setInterval(() => {
        n = n + step;
        this.displaySearches = n;
        if (n >= num) {
          clearInterval(interval);
        }
      }, t);
    },
    outNumFound(num, step) {
      var time = 70000;
      var n = 96332;
      var t = Math.round(time / (num / step));
      let interval = setInterval(() => {
        n += step;
        this.displayFound = n;
        if (n >= num) {
          clearInterval(interval);
        }
      }, t);
    },
  },
};
